var map = {
	"./af": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/af.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_af_js"
	],
	"./af.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/af.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_af_d_ts"
	],
	"./af.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/af.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_af_d_ts"
	],
	"./af.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/af.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_af_js"
	],
	"./ak": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ak.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ak_js"
	],
	"./ak.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ak.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ak_d_ts"
	],
	"./ak.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ak.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ak_d_ts"
	],
	"./ak.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ak.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ak_js"
	],
	"./am": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/am.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_am_js"
	],
	"./am.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/am.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_am_d_ts"
	],
	"./am.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/am.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_am_d_ts"
	],
	"./am.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/am.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_am_js"
	],
	"./an": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/an.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_an_js"
	],
	"./an.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/an.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_an_d_ts"
	],
	"./an.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/an.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_an_d_ts"
	],
	"./an.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/an.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_an_js"
	],
	"./ar": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ar.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ar_js"
	],
	"./ar.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ar.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ar_d_ts"
	],
	"./ar.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ar.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ar_d_ts"
	],
	"./ar.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ar.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ar_js"
	],
	"./ars": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ars.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ars_js"
	],
	"./ars.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ars.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ars_d_ts"
	],
	"./ars.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ars.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ars_d_ts"
	],
	"./ars.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ars.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ars_js"
	],
	"./as": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/as.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_as_js"
	],
	"./as.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/as.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_as_d_ts"
	],
	"./as.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/as.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_as_d_ts"
	],
	"./as.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/as.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_as_js"
	],
	"./asa": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/asa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_asa_js"
	],
	"./asa.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/asa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_asa_d_ts"
	],
	"./asa.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/asa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_asa_d_ts"
	],
	"./asa.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/asa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_asa_js"
	],
	"./ast": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ast.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ast_js"
	],
	"./ast.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ast.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ast_d_ts"
	],
	"./ast.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ast.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ast_d_ts"
	],
	"./ast.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ast.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ast_js"
	],
	"./az": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/az.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_az_js"
	],
	"./az.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/az.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_az_d_ts"
	],
	"./az.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/az.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_az_d_ts"
	],
	"./az.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/az.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_az_js"
	],
	"./bal": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bal.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bal_js"
	],
	"./bal.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bal.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bal_d_ts"
	],
	"./bal.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bal.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bal_d_ts"
	],
	"./bal.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bal.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bal_js"
	],
	"./be": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/be.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_be_js"
	],
	"./be.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/be.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_be_d_ts"
	],
	"./be.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/be.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_be_d_ts"
	],
	"./be.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/be.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_be_js"
	],
	"./bem": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bem.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bem_js"
	],
	"./bem.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bem.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bem_d_ts"
	],
	"./bem.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bem.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bem_d_ts"
	],
	"./bem.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bem.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bem_js"
	],
	"./bez": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bez.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bez_js"
	],
	"./bez.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bez.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bez_d_ts"
	],
	"./bez.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bez.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bez_d_ts"
	],
	"./bez.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bez.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bez_js"
	],
	"./bg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bg_js"
	],
	"./bg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bg_d_ts"
	],
	"./bg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bg_d_ts"
	],
	"./bg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bg_js"
	],
	"./bho": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bho.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bho_js"
	],
	"./bho.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bho.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bho_d_ts"
	],
	"./bho.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bho.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bho_d_ts"
	],
	"./bho.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bho.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bho_js"
	],
	"./bm": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bm_js"
	],
	"./bm.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bm_d_ts"
	],
	"./bm.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bm_d_ts"
	],
	"./bm.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bm_js"
	],
	"./bn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bn_js"
	],
	"./bn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bn_d_ts"
	],
	"./bn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bn_d_ts"
	],
	"./bn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bn_js"
	],
	"./bo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bo_js"
	],
	"./bo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bo_d_ts"
	],
	"./bo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bo_d_ts"
	],
	"./bo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bo_js"
	],
	"./br": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/br.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_br_js"
	],
	"./br.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/br.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_br_d_ts"
	],
	"./br.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/br.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_br_d_ts"
	],
	"./br.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/br.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_br_js"
	],
	"./brx": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/brx.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_brx_js"
	],
	"./brx.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/brx.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_brx_d_ts"
	],
	"./brx.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/brx.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_brx_d_ts"
	],
	"./brx.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/brx.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_brx_js"
	],
	"./bs": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bs.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bs_js"
	],
	"./bs.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bs.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bs_d_ts"
	],
	"./bs.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bs.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_bs_d_ts"
	],
	"./bs.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/bs.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_bs_js"
	],
	"./ca": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ca.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ca_js"
	],
	"./ca.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ca.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ca_d_ts"
	],
	"./ca.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ca.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ca_d_ts"
	],
	"./ca.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ca.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ca_js"
	],
	"./ce": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ce.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ce_js"
	],
	"./ce.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ce.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ce_d_ts"
	],
	"./ce.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ce.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ce_d_ts"
	],
	"./ce.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ce.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ce_js"
	],
	"./ceb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ceb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ceb_js"
	],
	"./ceb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ceb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ceb_d_ts"
	],
	"./ceb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ceb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ceb_d_ts"
	],
	"./ceb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ceb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ceb_js"
	],
	"./cgg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cgg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cgg_js"
	],
	"./cgg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cgg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cgg_d_ts"
	],
	"./cgg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cgg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cgg_d_ts"
	],
	"./cgg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cgg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cgg_js"
	],
	"./chr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/chr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_chr_js"
	],
	"./chr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/chr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_chr_d_ts"
	],
	"./chr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/chr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_chr_d_ts"
	],
	"./chr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/chr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_chr_js"
	],
	"./ckb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ckb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ckb_js"
	],
	"./ckb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ckb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ckb_d_ts"
	],
	"./ckb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ckb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ckb_d_ts"
	],
	"./ckb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ckb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ckb_js"
	],
	"./cs": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cs.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cs_js"
	],
	"./cs.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cs.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cs_d_ts"
	],
	"./cs.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cs.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cs_d_ts"
	],
	"./cs.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cs.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cs_js"
	],
	"./cy": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cy_js"
	],
	"./cy.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cy_d_ts"
	],
	"./cy.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_cy_d_ts"
	],
	"./cy.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/cy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_cy_js"
	],
	"./da": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/da.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_da_js"
	],
	"./da.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/da.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_da_d_ts"
	],
	"./da.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/da.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_da_d_ts"
	],
	"./da.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/da.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_da_js"
	],
	"./de": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/de.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_de_js"
	],
	"./de.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/de.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_de_d_ts"
	],
	"./de.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/de.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_de_d_ts"
	],
	"./de.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/de.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_de_js"
	],
	"./doi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/doi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_doi_js"
	],
	"./doi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/doi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_doi_d_ts"
	],
	"./doi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/doi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_doi_d_ts"
	],
	"./doi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/doi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_doi_js"
	],
	"./dsb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dsb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dsb_js"
	],
	"./dsb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dsb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dsb_d_ts"
	],
	"./dsb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dsb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dsb_d_ts"
	],
	"./dsb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dsb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dsb_js"
	],
	"./dv": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dv_js"
	],
	"./dv.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dv_d_ts"
	],
	"./dv.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dv_d_ts"
	],
	"./dv.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dv_js"
	],
	"./dz": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dz.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dz_js"
	],
	"./dz.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dz.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dz_d_ts"
	],
	"./dz.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dz.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_dz_d_ts"
	],
	"./dz.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/dz.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_dz_js"
	],
	"./ee": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ee.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ee_js"
	],
	"./ee.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ee.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ee_d_ts"
	],
	"./ee.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ee.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ee_d_ts"
	],
	"./ee.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ee.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ee_js"
	],
	"./el": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/el.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_el_js"
	],
	"./el.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/el.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_el_d_ts"
	],
	"./el.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/el.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_el_d_ts"
	],
	"./el.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/el.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_el_js"
	],
	"./en": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/en.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_en_js"
	],
	"./en.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/en.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_en_d_ts"
	],
	"./en.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/en.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_en_d_ts"
	],
	"./en.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/en.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_en_js"
	],
	"./eo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_eo_js"
	],
	"./eo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_eo_d_ts"
	],
	"./eo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_eo_d_ts"
	],
	"./eo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_eo_js"
	],
	"./es": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/es.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_es_js"
	],
	"./es.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/es.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_es_d_ts"
	],
	"./es.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/es.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_es_d_ts"
	],
	"./es.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/es.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_es_js"
	],
	"./et": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/et.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_et_js"
	],
	"./et.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/et.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_et_d_ts"
	],
	"./et.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/et.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_et_d_ts"
	],
	"./et.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/et.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_et_js"
	],
	"./eu": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_eu_js"
	],
	"./eu.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_eu_d_ts"
	],
	"./eu.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_eu_d_ts"
	],
	"./eu.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/eu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_eu_js"
	],
	"./fa": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fa_js"
	],
	"./fa.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fa_d_ts"
	],
	"./fa.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fa_d_ts"
	],
	"./fa.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fa_js"
	],
	"./ff": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ff.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ff_js"
	],
	"./ff.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ff.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ff_d_ts"
	],
	"./ff.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ff.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ff_d_ts"
	],
	"./ff.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ff.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ff_js"
	],
	"./fi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fi_js"
	],
	"./fi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fi_d_ts"
	],
	"./fi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fi_d_ts"
	],
	"./fi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fi_js"
	],
	"./fil": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fil.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fil_js"
	],
	"./fil.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fil.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fil_d_ts"
	],
	"./fil.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fil.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fil_d_ts"
	],
	"./fil.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fil.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fil_js"
	],
	"./fo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fo_js"
	],
	"./fo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fo_d_ts"
	],
	"./fo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fo_d_ts"
	],
	"./fo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fo_js"
	],
	"./fr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fr_js"
	],
	"./fr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fr_d_ts"
	],
	"./fr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fr_d_ts"
	],
	"./fr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fr_js"
	],
	"./fur": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fur.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fur_js"
	],
	"./fur.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fur.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fur_d_ts"
	],
	"./fur.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fur.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fur_d_ts"
	],
	"./fur.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fur.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fur_js"
	],
	"./fy": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fy_js"
	],
	"./fy.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fy_d_ts"
	],
	"./fy.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_fy_d_ts"
	],
	"./fy.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/fy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_fy_js"
	],
	"./ga": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ga.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ga_js"
	],
	"./ga.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ga.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ga_d_ts"
	],
	"./ga.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ga.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ga_d_ts"
	],
	"./ga.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ga.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ga_js"
	],
	"./gd": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gd_js"
	],
	"./gd.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gd_d_ts"
	],
	"./gd.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gd_d_ts"
	],
	"./gd.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gd_js"
	],
	"./gl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gl_js"
	],
	"./gl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gl_d_ts"
	],
	"./gl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gl_d_ts"
	],
	"./gl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gl_js"
	],
	"./gsw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gsw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gsw_js"
	],
	"./gsw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gsw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gsw_d_ts"
	],
	"./gsw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gsw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gsw_d_ts"
	],
	"./gsw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gsw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gsw_js"
	],
	"./gu": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gu_js"
	],
	"./gu.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gu_d_ts"
	],
	"./gu.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gu_d_ts"
	],
	"./gu.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gu_js"
	],
	"./guw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/guw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_guw_js"
	],
	"./guw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/guw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_guw_d_ts"
	],
	"./guw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/guw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_guw_d_ts"
	],
	"./guw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/guw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_guw_js"
	],
	"./gv": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gv_js"
	],
	"./gv.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gv_d_ts"
	],
	"./gv.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_gv_d_ts"
	],
	"./gv.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/gv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_gv_js"
	],
	"./ha": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ha.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ha_js"
	],
	"./ha.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ha.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ha_d_ts"
	],
	"./ha.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ha.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ha_d_ts"
	],
	"./ha.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ha.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ha_js"
	],
	"./haw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/haw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_haw_js"
	],
	"./haw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/haw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_haw_d_ts"
	],
	"./haw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/haw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_haw_d_ts"
	],
	"./haw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/haw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_haw_js"
	],
	"./he": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/he.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_he_js"
	],
	"./he.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/he.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_he_d_ts"
	],
	"./he.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/he.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_he_d_ts"
	],
	"./he.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/he.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_he_js"
	],
	"./hi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hi_js"
	],
	"./hi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hi_d_ts"
	],
	"./hi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hi_d_ts"
	],
	"./hi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hi_js"
	],
	"./hnj": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hnj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hnj_js"
	],
	"./hnj.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hnj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hnj_d_ts"
	],
	"./hnj.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hnj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hnj_d_ts"
	],
	"./hnj.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hnj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hnj_js"
	],
	"./hr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hr_js"
	],
	"./hr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hr_d_ts"
	],
	"./hr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hr_d_ts"
	],
	"./hr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hr_js"
	],
	"./hsb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hsb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hsb_js"
	],
	"./hsb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hsb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hsb_d_ts"
	],
	"./hsb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hsb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hsb_d_ts"
	],
	"./hsb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hsb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hsb_js"
	],
	"./hu": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hu_js"
	],
	"./hu.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hu_d_ts"
	],
	"./hu.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hu_d_ts"
	],
	"./hu.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hu_js"
	],
	"./hy": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hy_js"
	],
	"./hy.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hy_d_ts"
	],
	"./hy.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_hy_d_ts"
	],
	"./hy.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/hy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_hy_js"
	],
	"./ia": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ia.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ia_js"
	],
	"./ia.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ia.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ia_d_ts"
	],
	"./ia.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ia.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ia_d_ts"
	],
	"./ia.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ia.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ia_js"
	],
	"./id": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/id.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_id_js"
	],
	"./id.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/id.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_id_d_ts"
	],
	"./id.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/id.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_id_d_ts"
	],
	"./id.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/id.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_id_js"
	],
	"./ig": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ig.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ig_js"
	],
	"./ig.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ig.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ig_d_ts"
	],
	"./ig.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ig.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ig_d_ts"
	],
	"./ig.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ig.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ig_js"
	],
	"./ii": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ii.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ii_js"
	],
	"./ii.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ii.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ii_d_ts"
	],
	"./ii.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ii.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ii_d_ts"
	],
	"./ii.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ii.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ii_js"
	],
	"./io": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/io.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_io_js"
	],
	"./io.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/io.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_io_d_ts"
	],
	"./io.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/io.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_io_d_ts"
	],
	"./io.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/io.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_io_js"
	],
	"./is": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/is.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_is_js"
	],
	"./is.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/is.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_is_d_ts"
	],
	"./is.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/is.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_is_d_ts"
	],
	"./is.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/is.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_is_js"
	],
	"./it": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/it.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_it_js"
	],
	"./it.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/it.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_it_d_ts"
	],
	"./it.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/it.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_it_d_ts"
	],
	"./it.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/it.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_it_js"
	],
	"./iu": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/iu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_iu_js"
	],
	"./iu.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/iu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_iu_d_ts"
	],
	"./iu.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/iu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_iu_d_ts"
	],
	"./iu.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/iu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_iu_js"
	],
	"./ja": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ja.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ja_js"
	],
	"./ja.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ja.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ja_d_ts"
	],
	"./ja.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ja.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ja_d_ts"
	],
	"./ja.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ja.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ja_js"
	],
	"./jbo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jbo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jbo_js"
	],
	"./jbo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jbo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jbo_d_ts"
	],
	"./jbo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jbo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jbo_d_ts"
	],
	"./jbo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jbo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jbo_js"
	],
	"./jgo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jgo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jgo_js"
	],
	"./jgo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jgo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jgo_d_ts"
	],
	"./jgo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jgo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jgo_d_ts"
	],
	"./jgo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jgo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jgo_js"
	],
	"./jmc": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jmc.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jmc_js"
	],
	"./jmc.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jmc.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jmc_d_ts"
	],
	"./jmc.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jmc.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jmc_d_ts"
	],
	"./jmc.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jmc.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jmc_js"
	],
	"./jv": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jv_js"
	],
	"./jv.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jv_d_ts"
	],
	"./jv.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jv_d_ts"
	],
	"./jv.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jv_js"
	],
	"./jw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jw_js"
	],
	"./jw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jw_d_ts"
	],
	"./jw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_jw_d_ts"
	],
	"./jw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/jw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_jw_js"
	],
	"./ka": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ka.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ka_js"
	],
	"./ka.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ka.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ka_d_ts"
	],
	"./ka.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ka.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ka_d_ts"
	],
	"./ka.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ka.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ka_js"
	],
	"./kab": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kab.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kab_js"
	],
	"./kab.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kab.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kab_d_ts"
	],
	"./kab.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kab.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kab_d_ts"
	],
	"./kab.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kab.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kab_js"
	],
	"./kaj": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kaj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kaj_js"
	],
	"./kaj.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kaj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kaj_d_ts"
	],
	"./kaj.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kaj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kaj_d_ts"
	],
	"./kaj.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kaj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kaj_js"
	],
	"./kcg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kcg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kcg_js"
	],
	"./kcg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kcg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kcg_d_ts"
	],
	"./kcg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kcg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kcg_d_ts"
	],
	"./kcg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kcg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kcg_js"
	],
	"./kde": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kde.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kde_js"
	],
	"./kde.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kde.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kde_d_ts"
	],
	"./kde.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kde.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kde_d_ts"
	],
	"./kde.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kde.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kde_js"
	],
	"./kea": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kea.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kea_js"
	],
	"./kea.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kea.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kea_d_ts"
	],
	"./kea.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kea.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kea_d_ts"
	],
	"./kea.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kea.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kea_js"
	],
	"./kk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kk_js"
	],
	"./kk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kk_d_ts"
	],
	"./kk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kk_d_ts"
	],
	"./kk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kk_js"
	],
	"./kkj": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kkj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kkj_js"
	],
	"./kkj.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kkj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kkj_d_ts"
	],
	"./kkj.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kkj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kkj_d_ts"
	],
	"./kkj.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kkj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kkj_js"
	],
	"./kl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kl_js"
	],
	"./kl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kl_d_ts"
	],
	"./kl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kl_d_ts"
	],
	"./kl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kl_js"
	],
	"./km": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/km.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_km_js"
	],
	"./km.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/km.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_km_d_ts"
	],
	"./km.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/km.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_km_d_ts"
	],
	"./km.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/km.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_km_js"
	],
	"./kn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kn_js"
	],
	"./kn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kn_d_ts"
	],
	"./kn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kn_d_ts"
	],
	"./kn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kn_js"
	],
	"./ko": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ko.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ko_js"
	],
	"./ko.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ko.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ko_d_ts"
	],
	"./ko.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ko.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ko_d_ts"
	],
	"./ko.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ko.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ko_js"
	],
	"./ks": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ks.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ks_js"
	],
	"./ks.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ks.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ks_d_ts"
	],
	"./ks.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ks.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ks_d_ts"
	],
	"./ks.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ks.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ks_js"
	],
	"./ksb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksb_js"
	],
	"./ksb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksb_d_ts"
	],
	"./ksb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksb_d_ts"
	],
	"./ksb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksb_js"
	],
	"./ksh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksh_js"
	],
	"./ksh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksh_d_ts"
	],
	"./ksh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksh_d_ts"
	],
	"./ksh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ksh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ksh_js"
	],
	"./ku": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ku.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ku_js"
	],
	"./ku.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ku.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ku_d_ts"
	],
	"./ku.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ku.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ku_d_ts"
	],
	"./ku.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ku.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ku_js"
	],
	"./kw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kw_js"
	],
	"./kw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kw_d_ts"
	],
	"./kw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_kw_d_ts"
	],
	"./kw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/kw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_kw_js"
	],
	"./ky": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ky.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ky_js"
	],
	"./ky.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ky.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ky_d_ts"
	],
	"./ky.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ky.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ky_d_ts"
	],
	"./ky.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ky.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ky_js"
	],
	"./lag": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lag.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lag_js"
	],
	"./lag.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lag.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lag_d_ts"
	],
	"./lag.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lag.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lag_d_ts"
	],
	"./lag.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lag.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lag_js"
	],
	"./lb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lb_js"
	],
	"./lb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lb_d_ts"
	],
	"./lb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lb_d_ts"
	],
	"./lb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lb_js"
	],
	"./lg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lg_js"
	],
	"./lg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lg_d_ts"
	],
	"./lg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lg_d_ts"
	],
	"./lg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lg_js"
	],
	"./lij": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lij.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lij_js"
	],
	"./lij.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lij.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lij_d_ts"
	],
	"./lij.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lij.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lij_d_ts"
	],
	"./lij.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lij.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lij_js"
	],
	"./lkt": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lkt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lkt_js"
	],
	"./lkt.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lkt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lkt_d_ts"
	],
	"./lkt.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lkt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lkt_d_ts"
	],
	"./lkt.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lkt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lkt_js"
	],
	"./ln": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ln.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ln_js"
	],
	"./ln.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ln.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ln_d_ts"
	],
	"./ln.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ln.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ln_d_ts"
	],
	"./ln.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ln.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ln_js"
	],
	"./lo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lo_js"
	],
	"./lo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lo_d_ts"
	],
	"./lo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lo_d_ts"
	],
	"./lo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lo_js"
	],
	"./lt": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lt_js"
	],
	"./lt.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lt_d_ts"
	],
	"./lt.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lt_d_ts"
	],
	"./lt.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lt_js"
	],
	"./lv": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lv_js"
	],
	"./lv.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lv_d_ts"
	],
	"./lv.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_lv_d_ts"
	],
	"./lv.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/lv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_lv_js"
	],
	"./mas": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mas.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mas_js"
	],
	"./mas.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mas.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mas_d_ts"
	],
	"./mas.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mas.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mas_d_ts"
	],
	"./mas.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mas.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mas_js"
	],
	"./mg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mg_js"
	],
	"./mg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mg_d_ts"
	],
	"./mg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mg_d_ts"
	],
	"./mg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mg_js"
	],
	"./mgo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mgo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mgo_js"
	],
	"./mgo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mgo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mgo_d_ts"
	],
	"./mgo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mgo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mgo_d_ts"
	],
	"./mgo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mgo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mgo_js"
	],
	"./mk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mk_js"
	],
	"./mk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mk_d_ts"
	],
	"./mk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mk_d_ts"
	],
	"./mk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mk_js"
	],
	"./ml": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ml.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ml_js"
	],
	"./ml.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ml.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ml_d_ts"
	],
	"./ml.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ml.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ml_d_ts"
	],
	"./ml.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ml.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ml_js"
	],
	"./mn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mn_js"
	],
	"./mn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mn_d_ts"
	],
	"./mn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mn_d_ts"
	],
	"./mn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mn_js"
	],
	"./mo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mo_js"
	],
	"./mo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mo_d_ts"
	],
	"./mo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mo_d_ts"
	],
	"./mo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mo_js"
	],
	"./mr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mr_js"
	],
	"./mr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mr_d_ts"
	],
	"./mr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mr_d_ts"
	],
	"./mr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mr_js"
	],
	"./ms": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ms.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ms_js"
	],
	"./ms.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ms.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ms_d_ts"
	],
	"./ms.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ms.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ms_d_ts"
	],
	"./ms.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ms.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ms_js"
	],
	"./mt": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mt_js"
	],
	"./mt.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mt_d_ts"
	],
	"./mt.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_mt_d_ts"
	],
	"./mt.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/mt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_mt_js"
	],
	"./my": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/my.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_my_js"
	],
	"./my.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/my.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_my_d_ts"
	],
	"./my.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/my.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_my_d_ts"
	],
	"./my.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/my.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_my_js"
	],
	"./nah": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nah.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nah_js"
	],
	"./nah.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nah.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nah_d_ts"
	],
	"./nah.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nah.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nah_d_ts"
	],
	"./nah.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nah.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nah_js"
	],
	"./naq": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/naq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_naq_js"
	],
	"./naq.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/naq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_naq_d_ts"
	],
	"./naq.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/naq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_naq_d_ts"
	],
	"./naq.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/naq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_naq_js"
	],
	"./nb": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nb_js"
	],
	"./nb.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nb_d_ts"
	],
	"./nb.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nb.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nb_d_ts"
	],
	"./nb.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nb.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nb_js"
	],
	"./nd": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nd_js"
	],
	"./nd.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nd_d_ts"
	],
	"./nd.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nd_d_ts"
	],
	"./nd.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nd_js"
	],
	"./ne": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ne.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ne_js"
	],
	"./ne.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ne.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ne_d_ts"
	],
	"./ne.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ne.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ne_d_ts"
	],
	"./ne.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ne.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ne_js"
	],
	"./nl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nl_js"
	],
	"./nl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nl_d_ts"
	],
	"./nl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nl_d_ts"
	],
	"./nl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nl_js"
	],
	"./nn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nn_js"
	],
	"./nn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nn_d_ts"
	],
	"./nn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nn_d_ts"
	],
	"./nn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nn_js"
	],
	"./nnh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nnh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nnh_js"
	],
	"./nnh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nnh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nnh_d_ts"
	],
	"./nnh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nnh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nnh_d_ts"
	],
	"./nnh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nnh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nnh_js"
	],
	"./no": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/no.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_no_js"
	],
	"./no.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/no.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_no_d_ts"
	],
	"./no.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/no.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_no_d_ts"
	],
	"./no.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/no.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_no_js"
	],
	"./nqo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nqo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nqo_js"
	],
	"./nqo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nqo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nqo_d_ts"
	],
	"./nqo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nqo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nqo_d_ts"
	],
	"./nqo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nqo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nqo_js"
	],
	"./nr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nr_js"
	],
	"./nr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nr_d_ts"
	],
	"./nr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nr_d_ts"
	],
	"./nr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nr_js"
	],
	"./nso": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nso.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nso_js"
	],
	"./nso.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nso.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nso_d_ts"
	],
	"./nso.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nso.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nso_d_ts"
	],
	"./nso.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nso.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nso_js"
	],
	"./ny": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ny.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ny_js"
	],
	"./ny.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ny.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ny_d_ts"
	],
	"./ny.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ny.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ny_d_ts"
	],
	"./ny.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ny.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ny_js"
	],
	"./nyn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nyn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nyn_js"
	],
	"./nyn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nyn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nyn_d_ts"
	],
	"./nyn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nyn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_nyn_d_ts"
	],
	"./nyn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/nyn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_nyn_js"
	],
	"./om": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/om.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_om_js"
	],
	"./om.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/om.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_om_d_ts"
	],
	"./om.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/om.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_om_d_ts"
	],
	"./om.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/om.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_om_js"
	],
	"./or": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/or.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_or_js"
	],
	"./or.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/or.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_or_d_ts"
	],
	"./or.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/or.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_or_d_ts"
	],
	"./or.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/or.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_or_js"
	],
	"./os": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/os.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_os_js"
	],
	"./os.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/os.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_os_d_ts"
	],
	"./os.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/os.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_os_d_ts"
	],
	"./os.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/os.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_os_js"
	],
	"./osa": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/osa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_osa_js"
	],
	"./osa.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/osa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_osa_d_ts"
	],
	"./osa.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/osa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_osa_d_ts"
	],
	"./osa.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/osa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_osa_js"
	],
	"./pa": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pa_js"
	],
	"./pa.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pa_d_ts"
	],
	"./pa.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pa_d_ts"
	],
	"./pa.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pa_js"
	],
	"./pap": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pap.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pap_js"
	],
	"./pap.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pap.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pap_d_ts"
	],
	"./pap.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pap.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pap_d_ts"
	],
	"./pap.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pap.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pap_js"
	],
	"./pcm": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pcm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pcm_js"
	],
	"./pcm.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pcm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pcm_d_ts"
	],
	"./pcm.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pcm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pcm_d_ts"
	],
	"./pcm.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pcm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pcm_js"
	],
	"./pl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pl_js"
	],
	"./pl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pl_d_ts"
	],
	"./pl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pl_d_ts"
	],
	"./pl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pl_js"
	],
	"./prg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/prg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_prg_js"
	],
	"./prg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/prg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_prg_d_ts"
	],
	"./prg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/prg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_prg_d_ts"
	],
	"./prg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/prg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_prg_js"
	],
	"./ps": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ps.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ps_js"
	],
	"./ps.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ps.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ps_d_ts"
	],
	"./ps.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ps.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ps_d_ts"
	],
	"./ps.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ps.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ps_js"
	],
	"./pt": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt_js"
	],
	"./pt-PT": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt-PT.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt-PT_js"
	],
	"./pt-PT.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt-PT.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt-PT_d_ts"
	],
	"./pt-PT.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt-PT.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt-PT_d_ts"
	],
	"./pt-PT.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt-PT.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt-PT_js"
	],
	"./pt.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt_d_ts"
	],
	"./pt.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt_d_ts"
	],
	"./pt.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/pt.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_pt_js"
	],
	"./rm": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rm_js"
	],
	"./rm.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rm_d_ts"
	],
	"./rm.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rm_d_ts"
	],
	"./rm.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rm_js"
	],
	"./ro": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ro.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ro_js"
	],
	"./ro.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ro.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ro_d_ts"
	],
	"./ro.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ro.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ro_d_ts"
	],
	"./ro.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ro.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ro_js"
	],
	"./rof": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rof.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rof_js"
	],
	"./rof.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rof.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rof_d_ts"
	],
	"./rof.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rof.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rof_d_ts"
	],
	"./rof.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rof.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rof_js"
	],
	"./ru": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ru.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ru_js"
	],
	"./ru.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ru.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ru_d_ts"
	],
	"./ru.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ru.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ru_d_ts"
	],
	"./ru.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ru.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ru_js"
	],
	"./rwk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rwk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rwk_js"
	],
	"./rwk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rwk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rwk_d_ts"
	],
	"./rwk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rwk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_rwk_d_ts"
	],
	"./rwk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/rwk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_rwk_js"
	],
	"./sah": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sah.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sah_js"
	],
	"./sah.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sah.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sah_d_ts"
	],
	"./sah.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sah.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sah_d_ts"
	],
	"./sah.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sah.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sah_js"
	],
	"./saq": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/saq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_saq_js"
	],
	"./saq.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/saq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_saq_d_ts"
	],
	"./saq.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/saq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_saq_d_ts"
	],
	"./saq.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/saq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_saq_js"
	],
	"./sat": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sat.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sat_js"
	],
	"./sat.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sat.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sat_d_ts"
	],
	"./sat.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sat.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sat_d_ts"
	],
	"./sat.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sat.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sat_js"
	],
	"./sc": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sc.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sc_js"
	],
	"./sc.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sc.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sc_d_ts"
	],
	"./sc.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sc.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sc_d_ts"
	],
	"./sc.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sc.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sc_js"
	],
	"./scn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/scn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_scn_js"
	],
	"./scn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/scn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_scn_d_ts"
	],
	"./scn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/scn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_scn_d_ts"
	],
	"./scn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/scn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_scn_js"
	],
	"./sd": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sd_js"
	],
	"./sd.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sd_d_ts"
	],
	"./sd.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sd.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sd_d_ts"
	],
	"./sd.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sd.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sd_js"
	],
	"./sdh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sdh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sdh_js"
	],
	"./sdh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sdh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sdh_d_ts"
	],
	"./sdh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sdh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sdh_d_ts"
	],
	"./sdh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sdh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sdh_js"
	],
	"./se": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/se.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_se_js"
	],
	"./se.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/se.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_se_d_ts"
	],
	"./se.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/se.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_se_d_ts"
	],
	"./se.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/se.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_se_js"
	],
	"./seh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/seh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_seh_js"
	],
	"./seh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/seh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_seh_d_ts"
	],
	"./seh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/seh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_seh_d_ts"
	],
	"./seh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/seh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_seh_js"
	],
	"./ses": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ses.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ses_js"
	],
	"./ses.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ses.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ses_d_ts"
	],
	"./ses.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ses.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ses_d_ts"
	],
	"./ses.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ses.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ses_js"
	],
	"./sg": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sg_js"
	],
	"./sg.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sg_d_ts"
	],
	"./sg.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sg.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sg_d_ts"
	],
	"./sg.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sg.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sg_js"
	],
	"./sh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sh_js"
	],
	"./sh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sh_d_ts"
	],
	"./sh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sh_d_ts"
	],
	"./sh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sh_js"
	],
	"./shi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/shi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_shi_js"
	],
	"./shi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/shi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_shi_d_ts"
	],
	"./shi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/shi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_shi_d_ts"
	],
	"./shi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/shi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_shi_js"
	],
	"./si": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/si.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_si_js"
	],
	"./si.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/si.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_si_d_ts"
	],
	"./si.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/si.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_si_d_ts"
	],
	"./si.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/si.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_si_js"
	],
	"./sk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sk_js"
	],
	"./sk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sk_d_ts"
	],
	"./sk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sk_d_ts"
	],
	"./sk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sk_js"
	],
	"./sl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sl_js"
	],
	"./sl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sl_d_ts"
	],
	"./sl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sl_d_ts"
	],
	"./sl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sl_js"
	],
	"./sma": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sma.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sma_js"
	],
	"./sma.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sma.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sma_d_ts"
	],
	"./sma.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sma.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sma_d_ts"
	],
	"./sma.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sma.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sma_js"
	],
	"./smi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smi_js"
	],
	"./smi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smi_d_ts"
	],
	"./smi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smi_d_ts"
	],
	"./smi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smi_js"
	],
	"./smj": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smj_js"
	],
	"./smj.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smj_d_ts"
	],
	"./smj.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smj.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smj_d_ts"
	],
	"./smj.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smj.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smj_js"
	],
	"./smn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smn_js"
	],
	"./smn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smn_d_ts"
	],
	"./smn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_smn_d_ts"
	],
	"./smn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/smn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_smn_js"
	],
	"./sms": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sms.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sms_js"
	],
	"./sms.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sms.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sms_d_ts"
	],
	"./sms.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sms.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sms_d_ts"
	],
	"./sms.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sms.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sms_js"
	],
	"./sn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sn_js"
	],
	"./sn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sn_d_ts"
	],
	"./sn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sn_d_ts"
	],
	"./sn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sn_js"
	],
	"./so": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/so.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_so_js"
	],
	"./so.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/so.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_so_d_ts"
	],
	"./so.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/so.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_so_d_ts"
	],
	"./so.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/so.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_so_js"
	],
	"./sq": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sq_js"
	],
	"./sq.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sq_d_ts"
	],
	"./sq.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sq.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sq_d_ts"
	],
	"./sq.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sq.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sq_js"
	],
	"./sr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sr_js"
	],
	"./sr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sr_d_ts"
	],
	"./sr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sr_d_ts"
	],
	"./sr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sr_js"
	],
	"./ss": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ss.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ss_js"
	],
	"./ss.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ss.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ss_d_ts"
	],
	"./ss.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ss.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ss_d_ts"
	],
	"./ss.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ss.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ss_js"
	],
	"./ssy": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ssy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ssy_js"
	],
	"./ssy.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ssy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ssy_d_ts"
	],
	"./ssy.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ssy.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ssy_d_ts"
	],
	"./ssy.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ssy.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ssy_js"
	],
	"./st": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/st.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_st_js"
	],
	"./st.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/st.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_st_d_ts"
	],
	"./st.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/st.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_st_d_ts"
	],
	"./st.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/st.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_st_js"
	],
	"./su": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/su.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_su_js"
	],
	"./su.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/su.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_su_d_ts"
	],
	"./su.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/su.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_su_d_ts"
	],
	"./su.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/su.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_su_js"
	],
	"./sv": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sv_js"
	],
	"./sv.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sv_d_ts"
	],
	"./sv.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sv.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sv_d_ts"
	],
	"./sv.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sv.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sv_js"
	],
	"./sw": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sw_js"
	],
	"./sw.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sw_d_ts"
	],
	"./sw.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sw.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_sw_d_ts"
	],
	"./sw.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/sw.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_sw_js"
	],
	"./syr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/syr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_syr_js"
	],
	"./syr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/syr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_syr_d_ts"
	],
	"./syr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/syr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_syr_d_ts"
	],
	"./syr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/syr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_syr_js"
	],
	"./ta": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ta.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ta_js"
	],
	"./ta.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ta.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ta_d_ts"
	],
	"./ta.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ta.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ta_d_ts"
	],
	"./ta.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ta.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ta_js"
	],
	"./te": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/te.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_te_js"
	],
	"./te.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/te.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_te_d_ts"
	],
	"./te.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/te.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_te_d_ts"
	],
	"./te.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/te.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_te_js"
	],
	"./teo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/teo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_teo_js"
	],
	"./teo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/teo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_teo_d_ts"
	],
	"./teo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/teo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_teo_d_ts"
	],
	"./teo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/teo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_teo_js"
	],
	"./th": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/th.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_th_js"
	],
	"./th.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/th.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_th_d_ts"
	],
	"./th.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/th.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_th_d_ts"
	],
	"./th.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/th.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_th_js"
	],
	"./ti": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ti.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ti_js"
	],
	"./ti.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ti.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ti_d_ts"
	],
	"./ti.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ti.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ti_d_ts"
	],
	"./ti.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ti.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ti_js"
	],
	"./tig": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tig.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tig_js"
	],
	"./tig.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tig.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tig_d_ts"
	],
	"./tig.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tig.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tig_d_ts"
	],
	"./tig.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tig.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tig_js"
	],
	"./tk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tk_js"
	],
	"./tk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tk_d_ts"
	],
	"./tk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tk_d_ts"
	],
	"./tk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tk_js"
	],
	"./tl": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tl_js"
	],
	"./tl.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tl_d_ts"
	],
	"./tl.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tl.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tl_d_ts"
	],
	"./tl.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tl.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tl_js"
	],
	"./tn": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tn_js"
	],
	"./tn.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tn_d_ts"
	],
	"./tn.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tn.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tn_d_ts"
	],
	"./tn.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tn.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tn_js"
	],
	"./to": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/to.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_to_js"
	],
	"./to.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/to.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_to_d_ts"
	],
	"./to.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/to.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_to_d_ts"
	],
	"./to.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/to.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_to_js"
	],
	"./tpi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tpi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tpi_js"
	],
	"./tpi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tpi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tpi_d_ts"
	],
	"./tpi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tpi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tpi_d_ts"
	],
	"./tpi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tpi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tpi_js"
	],
	"./tr": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tr_js"
	],
	"./tr.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tr_d_ts"
	],
	"./tr.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tr.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tr_d_ts"
	],
	"./tr.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tr.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tr_js"
	],
	"./ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ts.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ts_js"
	],
	"./ts.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ts.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ts_d_ts"
	],
	"./ts.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ts.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ts_d_ts"
	],
	"./ts.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ts.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ts_js"
	],
	"./tzm": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tzm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tzm_js"
	],
	"./tzm.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tzm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tzm_d_ts"
	],
	"./tzm.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tzm.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_tzm_d_ts"
	],
	"./tzm.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/tzm.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_tzm_js"
	],
	"./ug": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ug.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ug_js"
	],
	"./ug.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ug.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ug_d_ts"
	],
	"./ug.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ug.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ug_d_ts"
	],
	"./ug.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ug.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ug_js"
	],
	"./uk": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_uk_js"
	],
	"./uk.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_uk_d_ts"
	],
	"./uk.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uk.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_uk_d_ts"
	],
	"./uk.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uk.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_uk_js"
	],
	"./und": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/und.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_und_js"
	],
	"./und.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/und.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_und_d_ts"
	],
	"./und.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/und.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_und_d_ts"
	],
	"./und.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/und.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_und_js"
	],
	"./ur": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ur.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ur_js"
	],
	"./ur.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ur.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ur_d_ts"
	],
	"./ur.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ur.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ur_d_ts"
	],
	"./ur.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ur.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ur_js"
	],
	"./uz": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uz.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_uz_js"
	],
	"./uz.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uz.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_uz_d_ts"
	],
	"./uz.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uz.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_uz_d_ts"
	],
	"./uz.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/uz.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_uz_js"
	],
	"./ve": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ve.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ve_js"
	],
	"./ve.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ve.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ve_d_ts"
	],
	"./ve.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ve.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_ve_d_ts"
	],
	"./ve.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/ve.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_ve_js"
	],
	"./vi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vi_js"
	],
	"./vi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vi_d_ts"
	],
	"./vi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vi_d_ts"
	],
	"./vi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vi_js"
	],
	"./vo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vo_js"
	],
	"./vo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vo_d_ts"
	],
	"./vo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vo_d_ts"
	],
	"./vo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vo_js"
	],
	"./vun": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vun.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vun_js"
	],
	"./vun.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vun.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vun_d_ts"
	],
	"./vun.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vun.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_vun_d_ts"
	],
	"./vun.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/vun.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_vun_js"
	],
	"./wa": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wa_js"
	],
	"./wa.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wa_d_ts"
	],
	"./wa.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wa.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wa_d_ts"
	],
	"./wa.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wa.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wa_js"
	],
	"./wae": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wae.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wae_js"
	],
	"./wae.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wae.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wae_d_ts"
	],
	"./wae.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wae.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wae_d_ts"
	],
	"./wae.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wae.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wae_js"
	],
	"./wo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wo_js"
	],
	"./wo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wo_d_ts"
	],
	"./wo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_wo_d_ts"
	],
	"./wo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/wo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_wo_js"
	],
	"./xh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_xh_js"
	],
	"./xh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_xh_d_ts"
	],
	"./xh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_xh_d_ts"
	],
	"./xh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_xh_js"
	],
	"./xog": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xog.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_xog_js"
	],
	"./xog.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xog.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_xog_d_ts"
	],
	"./xog.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xog.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_xog_d_ts"
	],
	"./xog.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/xog.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_xog_js"
	],
	"./yi": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yi_js"
	],
	"./yi.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yi_d_ts"
	],
	"./yi.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yi.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yi_d_ts"
	],
	"./yi.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yi.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yi_js"
	],
	"./yo": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yo_js"
	],
	"./yo.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yo_d_ts"
	],
	"./yo.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yo.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yo_d_ts"
	],
	"./yo.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yo.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yo_js"
	],
	"./yue": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yue.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yue_js"
	],
	"./yue.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yue.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yue_d_ts"
	],
	"./yue.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yue.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_yue_d_ts"
	],
	"./yue.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/yue.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_yue_js"
	],
	"./zh": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_zh_js"
	],
	"./zh.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_zh_d_ts"
	],
	"./zh.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zh.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_zh_d_ts"
	],
	"./zh.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zh.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_zh_js"
	],
	"./zu": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_zu_js"
	],
	"./zu.d": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_zu_d_ts"
	],
	"./zu.d.ts": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zu.d.ts",
		9,
		"node_modules_formatjs_intl-pluralrules_locale-data_zu_d_ts"
	],
	"./zu.js": [
		"./node_modules/@formatjs/intl-pluralrules/locale-data/zu.js",
		7,
		"node_modules_formatjs_intl-pluralrules_locale-data_zu_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./node_modules/@formatjs/intl-pluralrules/locale-data ../node_modules/@formatjs/intl-pluralrules/locale-data ./node_modules/@formatjs/intl-pluralrules/locale-data lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;